import { useEffect, useState, useMemo } from 'react';
import api from "../services/axiosInstance";
import { backendPort } from "../components/Fungsiku";
import { useNotification } from './NotifPopup';

const JENIS_SUPLIER_OPTIONS = ['suplier', 'pabrik', 'mitra', 'lain-lain'];

const parseTelapakList = (raw) => String(raw || '')
  .split('#')
  .map((item) => String(item || '').trim())
  .filter(Boolean);

//DAFTAR SUPLIER
export function PageKonten31DaftarSuplier({ token }) {
  const [data, setData] = useState([{ id: '', suplier: '' }]);
  const [nama, setNama] = useState('');

  const [sortBy, setSortBy] = useState('nama');
  const [sortDir, setSortDir] = useState('asc');
  const [showTambah, setShowTambah] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [editData, setEditData] = useState({ id: '', nama: '', jenis: 'suplier', telapak: [] });
  const [showHapus, setShowHapus] = useState(false);
  const [hapusData, setHapusData] = useState({ id: '', nama: '' });
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const { showNotif } = useNotification();

  const loadData = async () => {
    try {
      const res = await api.get(`${backendPort}/api/master/daftar_suplier`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const sortedData = [...(res?.data || [])].sort((a, b) =>
        String(a?.suplier || '').localeCompare(String(b?.suplier || ''))
      );
      setData(sortedData);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const filteredData = useMemo(() => {
    return data.filter((item) => {
      const searchMatch =
        String(item?.suplier || '').toLowerCase().includes(search?.toLowerCase() ?? '');
      return searchMatch;
    });
  }, [data, search]);

  const PAGE_SIZE_OPTIONS = [5, 10, 20];
  const totalPages = Math.max(1, Math.ceil(filteredData.length / pageSize));
  const paginatedData = filteredData.slice(
    (page - 1) * pageSize,
    page * pageSize
  );
  const maxVisible = 5;
  let startPage = Math.max(1, page - Math.floor(maxVisible / 2));
  let endPage = startPage + maxVisible - 1;
  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(1, endPage - maxVisible + 1);
  }
  const visiblePages = [];
  for (let i = startPage; i <= endPage; i++) {
    visiblePages.push(i);
  }

  const handleTambah = async (e) => {
    try {
      e.preventDefault();
      setShowTambah(false);
      await api.post(`${backendPort}/api/master/tambah_suplier`, {
        nama,
      });

      setNama('');
      await loadData();
      showNotif('success', 'Data Berhasil Ditambahkan');
    } catch (err) {
      showNotif('error', 'Penambahan Data Error');
    }
  };

  const handleEdit = async (e) => {
    try {
      setShowEdit(false);
      e.preventDefault();
      await api.put(`${backendPort}/api/master/edit_suplier`, {
        id: editData.id,
        nama: editData.nama,
        jenis: editData.jenis,
        telapak: editData.telapak,
      });
      showNotif('success', 'Update Data Berhasil');
      await loadData();
    } catch (err) {
      showNotif('error', 'Update Data Error');
    }
  };

  const handleDelete = async (e) => {
    try {
      if (e) e.preventDefault();
      setShowHapus(false);

      await api.delete(`${backendPort}/api/master/delete_suplier/${hapusData.id}`);

      showNotif('success', 'Delete Data Berhasil');
      await loadData();
      setHapusData({ id: '', nama: '' });
    } catch (err) {
      showNotif('error', 'Delete Data Error');
    }
  };

  const handleSort = (field) => {
    if (sortBy === field) {
      setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(field);
      setSortDir('asc');
    }
  };

  const sortedData = [...paginatedData].sort((a, b) => {
    if (!sortBy) return 0;

    const valA = sortBy === 'kode' ? String(a.id || '') : String(a.suplier || '');
    const valB = sortBy === 'kode' ? String(b.id || '') : String(b.suplier || '');

    if (sortDir === 'asc') {
      return valA.localeCompare(valB);
    }
    return valB.localeCompare(valA);
  });

  const handleRemoveTelapak = (targetIndex) => {
    setEditData((prev) => ({
      ...prev,
      telapak: (prev.telapak || []).filter((_, index) => index !== targetIndex),
    }));
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-6">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center" style={{ background: "#09314F", color: "#fff" }}>
              Daftar Suplier
              <button
                className="btn btn-outline-secondary ls"
                style={{ fontSize: "large", color: "#fff" }}
                onClick={() => {
                  setShowTambah(!showTambah);
                  setShowEdit(false);
                  setShowHapus(false);
                  setNama('');
                }}
              >
                Tambah <i className="fa fa-add"></i>
              </button>
            </div>

            <div className="card-body p-0">
              <div className="row my-2 mx-1">
                <div className="col-md-4">
                  <input
                    className="form-control"
                    placeholder="Cari..."
                    value={search}
                    onChange={(e) => {
                      setSearch(e.target.value);
                      setPage(1);
                    }}
                  />
                </div>
                <div className="col-md-4"></div>
                <div className="col-md-4 text-end">
                  <label className="form-label">Show</label>
                  <select
                    className="form-select w-auto d-inline-block ms-2"
                    value={pageSize}
                    onChange={(e) => {
                      setPageSize(Number(e.target.value));
                      setPage(1);
                    }}
                  >
                    {PAGE_SIZE_OPTIONS.map((x) => (
                      <option key={x}>{x}</option>
                    ))}
                  </select>
                </div>
              </div>
              <table className="table table-bordered table-hover">
                <thead>
                  <tr>
                    <th onClick={() => handleSort('kode')} style={{ cursor: 'pointer' }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Kode</span>
                        {sortBy === 'kode' && <span>{sortDir === 'asc' ? '▲' : '▼'}</span>}
                      </div>
                    </th>

                    <th onClick={() => handleSort('nama')} style={{ cursor: 'pointer' }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Suplier</span>
                        {sortBy === 'nama' && <span>{sortDir === 'asc' ? '▲' : '▼'}</span>}
                      </div>
                    </th>

                    <th width="80">Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedData.map((row) => (
                    <tr key={row.id}>
                      <td>{`S-${row.id}`}</td>
                      <td>{row.suplier}</td>
                      <td className="d-flex justify-content-between align-items-center">
                        <span
                          onClick={() => {
                            const jenis = String(row?.jenis || '').trim().toLowerCase();
                            setEditData({
                              id: row.id,
                              nama: row.suplier,
                              jenis: JENIS_SUPLIER_OPTIONS.includes(jenis) ? jenis : 'suplier',
                              telapak: parseTelapakList(row?.telapak),
                            });
                            setShowEdit(!showEdit);
                            setShowTambah(false);
                            setShowHapus(false);
                          }}
                          style={{ cursor: 'pointer' }}
                        >
                          <i className="fa fa-folder-open"></i>
                        </span>

                        <span
                          onClick={() => {
                            setHapusData({ id: row.id, nama: row.suplier });
                            setShowHapus(!showHapus);
                            setShowTambah(false);
                            setShowEdit(false);
                          }}
                          style={{ cursor: 'pointer' }}
                        >
                          <i className="fa fa-trash text-red-500"></i>
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="d-flex justify-content-between align-items-center my-2 mx-3">
              <div>
                Showing {(page - 1) * pageSize + 1} to{' '}
                {Math.min(page * pageSize, filteredData.length)} of{' '}
                {filteredData.length} entries
              </div>

              <nav>
                <ul className="pagination mb-0">
                  <li className={`page-item ${page === 1 && 'disabled'}`}>
                    <button className="page-link" onClick={() => setPage(1)}>
                      ←
                    </button>
                  </li>

                  {visiblePages.map((p) => (
                    <li key={p} className={`page-item ${page === p && 'active'}`}>
                      <button className="page-link" onClick={() => setPage(p)}>
                        {p}
                      </button>
                    </li>
                  ))}

                  <li className={`page-item ${page === totalPages && 'disabled'}`}>
                    <button className="page-link" onClick={() => setPage(totalPages)}>
                      →
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>

        {showTambah && (
          <div className="col-md-4">
            <div className="card">
              <div className="card-header" style={{ background: "#09314F", color: "#fff" }}>
                Tambah Suplier
              </div>
              <div className="card-body">
                <form onSubmit={handleTambah}>
                  <div className="mb-3">
                    <label>Nama</label>
                    <input className="form-control" value={nama} onChange={(e) => setNama(e.target.value)} />
                  </div>

                  <button className="btn btn-primary me-2" disabled={!nama.trim()}>Simpan</button>
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={() => {
                      setNama('');
                      setShowTambah(false);
                    }}
                  >
                    Batal
                  </button>
                </form>
              </div>
            </div>
          </div>
        )}

        {showEdit && (
          <div className="col-md-4">
            <div className="card">
              <div className="card-header" style={{ background: "#09314F", color: "#fff" }}>
                Edit Suplier
              </div>
              <div className="card-body">
                <form onSubmit={handleEdit}>
                  <div className="mb-3">
                    <label>Kode</label>
                    <input className="form-control" value={`S-${editData.id}`} disabled />
                  </div>

                  <div className="mb-3">
                    <label>Nama</label>
                    <input
                      className="form-control"
                      value={editData.nama}
                      onChange={(e) => setEditData({ ...editData, nama: e.target.value })}
                    />
                  </div>

                  <div className="mb-3">
                    <label>Jenis Suplier</label>
                    <select
                      className="form-select"
                      value={editData.jenis}
                      onChange={(e) => setEditData({ ...editData, jenis: e.target.value })}
                    >
                      {JENIS_SUPLIER_OPTIONS.map((jenis) => (
                        <option key={jenis} value={jenis}>{jenis}</option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-3">
                    <label>Daftar Telapak</label>
                    {(editData.telapak || []).length === 0 ? (
                      <div className="text-muted fst-italic">Belum ada telapak</div>
                    ) : (
                      <div className="d-flex flex-column gap-2">
                        {(editData.telapak || []).map((item, index) => (
                          <div
                            key={`${item}-${index}`}
                            className="d-flex justify-content-between align-items-center border rounded px-2 py-1"
                          >
                            <span>{item}</span>
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => handleRemoveTelapak(index)}
                            >
                              Hapus
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <button className="btn btn-primary me-2" disabled={!String(editData.nama || '').trim()}>Update</button>

                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={() => {
                      setNama('');
                      setShowEdit(false);
                      setEditData({ id: '', nama: '', jenis: 'suplier', telapak: [] });
                    }}
                  >
                    Batal
                  </button>
                </form>
              </div>
            </div>
          </div>
        )}

        {showHapus && (
          <div className="col-md-4">
            <div className="card">
              <div className="card-header" style={{ background: "#dc3545", color: "#fff" }}>
                Hapus Suplier
              </div>
              <div className="card-body">
                <form onSubmit={handleDelete}>
                  <div className="mb-3">
                    <label>Kode</label>
                    <input className="form-control" value={`S-${hapusData.id}`} disabled />
                  </div>

                  <div className="mb-3">
                    <label>Nama</label>
                    <input className="form-control" value={hapusData.nama} disabled />
                  </div>

                  <button className="btn btn-danger me-2">Delete</button>

                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={() => {
                      setNama('');
                      setShowHapus(false);
                    }}
                  >
                    Batal
                  </button>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
